import pull from 'lodash/pull';
import find from 'lodash/find';
import ParticipationCard from '../participationCard';
import Icon from '../../components/icons';
import request from '../../request';

const emptyState = (text, icon) => `
  <article class="flex-full-width card-v2 margin-sm-btm">
    <section class="card-v2-body text-align-center">
      <p class="margin-sm">${icon}</p>
    </section>
    <footer class="card-v2-footer">
      <div class="divider margin-md-btm"></div>
      <div class="text-align-center">
        <p class="text-grey margin-reset">${text}</p>
      </div>
    </footer>
  </article>
`;
class PointsPage {
  constructor() {
    this.getText = Pollfish.ui.getText;
    this.container = document.createElement('div');
    this.participations = [];
    this.dailyPoints = 0;
    this.pendingPoints = 0;
    this.pointsName = Pollfish.helper.json.reward_name || 'Points';
    this.pendingSurveyIds = [];
  }

  getPoints() {
    this.container.innerHTML = `<div class="container">${Pollfish.ui.getSpinner()}</div>`;
    request({ url: '/v2/device/offerwall/points' })
      .then((payload = {}) => {
        if (!payload.success) {
          this.container.innerHTML = `<div class="container"><div class="margin-md">${this.renderErrorState()}</div></div>`;
          return;
        }

        this.showNotification(payload.data.participations);
        this.dailyPoints = payload.data.dailyPoints;
        this.pendingPoints = payload.data.pendingPoints;
        this.pointsName = payload.data.pointsName;
        this.participations = payload.data.participations;
        this.onChange();
        this.render();
        Pollfish.ui.renderReactOfferwallSortingComponent();
      })
      .catch(() => {
        this.container.innerHTML = `<div class="container"><div class="margin-md">${this.renderErrorState()}</div></div>`;
      });
  }

  onChange() {
    this.onChangeCallback(
      this.dailyPoints,
      this.pendingPoints,
      this.pointsName,
    );
  }

  onPointsChange(callback) {
    this.onChangeCallback = callback;
  }

  showNotification(nextParticipations) {
    const { participations } = this;

    // concatenate all pending survey ids
    const pendingSurveyParticipations = participations.reduce(
      (accumulator, participation) => {
        if (participation.status === 'pending') {
          accumulator.push(participation.s_id);
        }

        return accumulator;
      },
      this.pendingSurveyIds,
    );

    const rewarded = find(nextParticipations, (participation) => {
      if (pendingSurveyParticipations.indexOf(participation.s_id) > -1) {
        return participation.status === 'success';
      }
      return false;
    });

    const screenOut = find(nextParticipations, (participation) => {
      if (pendingSurveyParticipations.indexOf(participation.s_id) > -1) {
        return participation.status === 'screened_out';
      }
      return false;
    });

    if (rewarded) {
      const successText = this.getText(
        'offerwall.notifications.congratulations',
      );
      const prompt = successText.replace(
        '...',
        `${rewarded.pointsValue} ${rewarded.pointsName}`,
      );
      Pollfish.ui.promptSuccess(prompt);
      pull(this.pendingSurveyIds, rewarded.s_id);
    }

    if (screenOut) {
      const promptText = this.getText('offerwall.notifications.disqualified');
      Pollfish.ui.promptError(promptText);
      pull(this.pendingSurveyIds, screenOut.s_id);
    }
  }

  renderEmptyState() {
    const { getText } = this;
    const emptyStateText = getText('offerwall.empty_history');
    return emptyState(
      emptyStateText,
      Icon({ type: 'empty', color: '#848d9e', size: 56 }),
    );
  }

  renderErrorState() {
    const { getText } = this;
    const text = getText('offerwall.error');
    return emptyState(text, Icon({ type: 'error', size: 56 }));
  }

  render() {
    const { getText, participations } = this;
    const title = `${getText('offerwall.history.survey_history')} (${getText(
      'offerwall.history.24_hours',
    )})`;
    this.container.innerHTML = `
      <div class="container points-container">
        <div class="text-align-center margin-lg">
          <h1 class="margin-reset font-bold">${title}</h1>
        </div>
        <section class="flex flex-wrap">
          ${participations
            .map((participation) => ParticipationCard(participation, getText))
            .join('')}
          <p class="text-align-center">${
            participations.length === 0 ? this.renderEmptyState() : ''
          }
            </p>
        </section>
      </div>`;

    return this.container;
  }
}

export default PointsPage;
